export default __webpack_public_path__ + "static/media/institution-umelb.7ae46e79.png";